import { BaseAddress } from 'types/global'

export const formatAddress = ({
  addressLine1,
  addressLine2,
  country,
  city,
  formatted,
  postalCode,
  province,
  suburb,
  ward,
}: BaseAddress) => {
  if (formatted) {
    return formatted
  }

  // Reorder fields according to how it will be concatenated
  const addressObj = {
    addressLine1,
    addressLine2,
    ward,
    suburb,
    city,
    province,
    country,
    postalCode,
  }

  let result = ''
  Object.entries(addressObj).forEach(([, val], index) => {
    if (val) {
      result += val
      if (index < Object.entries(addressObj).length - 1) {
        result += ', '
      }
    }
  })

  // Remove trailing spaces and comma
  result = result.trim()
  if (result.endsWith(',')) {
    result = result.slice(0, -1)
  }

  return result
}
